/* import config from 'c'; */
import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";

export const questionService = {
    getAllQuestionsByEvent,
    updateQuestion,
    create,
    updateRange,
    deleteQuestion
};

async function getAllQuestionsByEvent(eventId, includeInherited = false) {
    const requestOptions = {
        method: "GET",
        headers: authHeader({ "Content-Type": "application/json" }),
    };
    return fetch(`./api/question/${eventId}/?includeInherited=${includeInherited}`, requestOptions)
        .then(handleResponse)
        .then(questions => {
            return questions;
        });
}
async function updateQuestion(question) {
    const requestOptions = {
        method: "PUT",
        headers: authHeader({ "Content-Type": "application/json" }),
        body: JSON.stringify(question),
    };
    return fetch(`./api/question`, requestOptions)
        .then(handleResponse)
        .then(q => {
            return q;
        });

}
async function deleteQuestion(questionId) {
    const requestOptions = {
        method: "DELETE",
        headers: authHeader({ "Content-Type": "application/json" }),
    };
    return fetch(`./api/question/delete/${questionId}`, requestOptions)
        .then(handleResponse)
        .then(_ => {
            return questionId;
        });

}
async function updateRange(q) {
    const requestOptions = {
        method: "PUT",
        headers: authHeader({ "Content-Type": "application/json" }),
        body: JSON.stringify(q),
    };
    fetch(`./api/question/updaterange`, requestOptions)
        .then(handleResponse)
        .then(q => {
            return q;
        });
};

async function create(question) {
    const requestOptions = {
        method: "POST",
        headers: authHeader({ "Content-Type": "application/json" }),
        body: JSON.stringify(question),
    };
    return fetch(`./api/question`, requestOptions)
        .then(handleResponse)
        .then(q => {
            return q;
        });

}





